// namespace Hvd {
    export default class DialogUser {
        constructor() {

        }
    }
// }

// export = Hvd;
